import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import {
  TDakokuTenkoAlert,
  TDakokuTenkoAlertMarkAsReadPutReq,
} from "./TDakokuTenkoAlert"
import { TApiResponse } from "../../TApiResponse"

/**
 * 打刻点呼アラートに対するAPIリクエスト用サービス
 */
export default class DakokuTenkoAlertService extends ConnectApi {
  /**
   * 未読リスト取得
   * @returns
   */
  getUnreadList = async () => {
    try {
      const res: AxiosResponse<TApiResponse<TDakokuTenkoAlert[]>> =
        await this.getInner(`/kintai/dakokuTenkoAlert/unreadList`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 既読更新
   * @param id
   * @param data
   * @returns
   */
  putMarkAsRead = async (
    id: number,
    data: TDakokuTenkoAlertMarkAsReadPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/kintai/dakokuTenkoAlert/${id}/markAsRead`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
